import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Borre Haugen
 * id D4A857FB-53DF-4726-9B49-986C83844E40
 * name coach-lamp-variant
 * version: 6.7.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/coach-lamp-variant.svg
 * tags
 * - Home Automation 
 */
export const CoachLampVariantIcon = createSvgIcon(<><path d="M12.5 2L12 4L10 6.31L5 9H7L9.5 18L12 20L12.5 22H13.5L14 20L16.5 18L19 9H21L16 6.31L14 4L13.5 2M9 9H17L14.78 17H11.22M3 14V22H11.5L11 20H8L5 17V14Z" /></>, 'CoachLampVariantIcon');
export default CoachLampVariantIcon